<div *ngIf="isSensorImportModalReady; else loading">

  <p-confirmDialog #cd>
      <ng-template #footer>
          <button (click)="cd.onAccept()" class="btn btn-success" type="button">Yes</button>
          <button (click)="cd.onReject()" class="btn btn-basic" type="button">No</button>
      </ng-template>
  </p-confirmDialog>

  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="sensorImport-modal">
  <!-- <div class="modal-content sensorImport-modal"> -->
    <!-- <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;"> -->
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Bulk Import for New and Updated Sensors</h5>
        <button
            (click)="bsModalRef.hide()"
            class="ms-auto fas fa-times"pe="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
        </button>
    </div>

    <div class="modal-body">
      <div style="display: flex; gap: 10px;">
        <div class="form-group" style="width: 750px;">
            <label style="margin-bottom: 10px;" for="file">Please select a comma delimited CSV file using the "Choose File" button. An example header row (column/field names) is shown below.</label>
            <label style="margin-left: 20px; width: 750px;">Example Header Row</label>
            <label style="font-size: 14px; margin-left: 40px; width: 850px; margin-bottom: 20px;">UUID, Name, Type, UserGroup, Notes, GPS_Lat, GPS_Long, GPS_StartDate, GPS_EndDate, GPS_LocationDescription</label>
            <label style="margin-left: 20px; width: 750px;">Notes</label>
            <label style="font-size: 14px; margin-left: 40px; width: 650px;">1. UUID is the only required field. All other fields are optional and do not need to be included in header row if not used.</label>
            <label style="font-size: 14px; margin-left: 40px; width: 650px;">2. Dates must be in given in UTC (example format:  2024-02-14T14:00:00Z)</label>
            <label style="font-size: 14px; margin-left: 40px; width: 650px;">3. UserGroup must be the name of an existing group</label>
            <input type="file" id="file" accept=".csv" (change)="csvFileSelected($event)" style="margin-top: 20px;">
            <i *ngIf="analyzingCSVFile" style="margin-left: 20px;" class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
        </div>
      </div>

      <div *ngIf="readyToImportFileContent">
        <hr>
        <div *ngFor="let result of importCSVFileAnalysisResults">
          {{ result }}
        </div>
        <hr>
        <i *ngIf="importingCSVFileContents" style="margin-right: 20px; float: right;" class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
        <button (click)="importCSVFileContent()" class="btn btn-success" style="width: 100px; float: right; margin-bottom: 15px;" type="button">Import</button>  
      </div>


    </div>
  </div>
</div>


<ng-template #loading>
  <div>
  <i class="fa fa-spinner fa-spin fa-1x fa-fw" style="margin: 30px 10px 30px 30px"></i>
  <span>Loading...</span>
  </div>
</ng-template>

